import { Box, Chip, Grid2 as Grid, Paper, Stack, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { LabelResource } from '../../../Entities/Label';
import { getLabelInputTypeName, LABEL_INPUT_TYPE } from '../../Labels/inputTypes';
import LabelField from './LabelField';
import { getCharacteristicKey, getLabelHelperText } from './utils';

interface ProductLabelsItemProps {
  label: LabelResource;
}

export default function ProductLabelsItem({ label }: ProductLabelsItemProps): ReactElement {
  const helperText = getLabelHelperText(label);

  return (
    <Grid size={{ xs: 12, lg: 6, xl: 4 }} sx={{ display: 'flex' }}>
      <Paper sx={{ height: '100%', p: 2, width: '100%' }} variant="outlined">
        <Stack spacing={1.5}>
          <Stack alignItems="flex-start" direction="row" justifyContent="space-between" spacing={1}>
            <Typography sx={{ flex: 1, minWidth: 0, wordBreak: 'break-word' }} variant="subtitle2">
              {(label.attributes.name ?? '').trim()}
            </Typography>
            <Chip
              label={getLabelInputTypeName(label.attributes.input_type)}
              size="small"
              sx={{ flexShrink: 0 }}
              variant="outlined"
            />
          </Stack>
          {helperText ? (
            <Typography color="text.secondary" variant="caption">
              {helperText}
            </Typography>
          ) : null}
          <Box
            sx={{
              '& .MuiFormGroup-root': {
                columnGap: 2,
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  md: 'repeat(2, minmax(0, 1fr))',
                },
                maxHeight: label.attributes.input_type === LABEL_INPUT_TYPE.LIST ? 260 : 'none',
                overflowY:
                  label.attributes.input_type === LABEL_INPUT_TYPE.LIST ? 'auto' : 'visible',
              },
            }}
          >
            <LabelField
              label={label}
              source={`characteristics.${getCharacteristicKey(label.id)}`}
            />
          </Box>
        </Stack>
      </Paper>
    </Grid>
  );
}
